import { Component, OnInit } from '@angular/core';
import {Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../services/authentication.service";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  model: any = {};
  loading = false;
  loginError : any = false;
  returnUrl: string;
  loginSuccess = false;

  constructor(private location: Location,
              private route: ActivatedRoute,
              private router: Router,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.returnUrl = 'dashboard';//this.route.snapshot.queryParams['returnUrl'] || '/';
    // reset login status
    if (localStorage.getItem('access_token') || localStorage.getItem('refresh_token')) {
     this.router.navigate([this.returnUrl]);
    } else {
    //  this.authenticationService.logout();
    }

  }

  forgotpassword(){
    const that = this;
    this.loading = true;
    this.authenticationService.forgotpassword().post({'email':this.model.email,'host':window.location.origin})
        .subscribe(
            data => {
            //  this.router.navigate([this.returnUrl]);
              that.loginError = false;
              that.loginSuccess = true;
            },
            error => {
              // this.alertService.error(error);
              this.loading = false;
              this.loginError = error.data.message;
              this.loginSuccess = false;
            });
  }
}



// WEBPACK FOOTER //
// /app/src/app/forgot-password/forgot-password.component.ts